import React from 'react'
import { BankOutlined, PlusOutlined, SwapOutlined } from '@ant-design/icons'
import { SectionAction, SectionKey, sectionOf } from '../../sections'
import ActionCard from '../ui/ActionCard'
import RecentChips from '../ui/RecentChips'

const actionIcons: Record<SectionAction['kind'], React.ReactNode> = {
    create: <PlusOutlined />,
    update: <SwapOutlined />,
    account: <BankOutlined />,
}

// One full-width card per action, so the longer descriptions stay readable
const SectionLanding: React.FC<{ section: SectionKey }> = ({ section }) => {
    const { actions, recentKinds } = sectionOf(section)

    return (
        <div className="stack">
            {actions.map((action) => (
                <ActionCard key={action.to} to={action.to} icon={actionIcons[action.kind]} title={action.title} description={action.description} />
            ))}
            <RecentChips kinds={recentKinds} showKind={recentKinds.length > 1} />
        </div>
    )
}

export default SectionLanding
